// extracted by css-extract-rspack-plugin
export default {"IconButton":"group-header-expansion-button-module__IconButton__D4Ls2"};